export interface LoginCredentials {
  email: string;
  password: string;
}

export interface AuthResponse {
  access_token: string;
  expires_at: string;
  token_type: string;
  user: AuthUser;
}

export interface AuthUser {
  email: string;
  id: number;
  name: string;
  status: UserStatus;
  role: UserRole;
}

export enum UserStatus {
  Inactive = 0,
  Active = 1,
}

export interface AuthState {
  user: AuthUser | null;
  token: string | null; 
  isAuthenticated: boolean;
}

export enum UserRole {
  ADMIN = 0,
  BROKER = 1,
}
